export const ROUTE_NUMERIC_PARAMS = ['bid', 'tid', 'cid', 'oid', 'rid', 'tagId'] as const
